module.exports = __webpack_public_path__ + "img/Dibasys_logo.bf6d770a.png";